import PredictionsDashboardContainer from './predictions-dashboard.container';

export * from './predictions-dashboard';
export * from './predictions-dashboard.container';
export default PredictionsDashboardContainer;
